<template>
    <div class="content">
        <!-- 客户详情 -->
         <Drawer
            title="客户详情"
            v-model="showUserDetails"
            width="1000"
            :scrollable="true"
            :mask-closable="false"
            :closable="false"
            :styles="styles">
            <!-- 编辑基本信息 -->
            <div v-if="showEditUserInfo">
                <div class="user_info_wrap">
                    <span class="user_info_title">基本信息</span>
                    <div>
                        <Button  type="primary" @click="handleSubmit('userInfoForm')">保存</Button>
                        <Button  type="primary" @click="handleReset('userInfoForm')">取消</Button>
                    </div>
                </div>
                <Form ref="userInfoForm" :model="userInfoForm" :rules="userInfoFormRule" :label-width="80" >
                    <Row>
                        <Col span="8" >
                            <FormItem label="姓名" prop="name" >
                                <Input v-model="userInfoForm.name" placeholder="请输入姓名"></Input>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="身份证" >
                                <Input v-model="userInfoForm.id_card" placeholder="请输入身份证" :maxlength="18" @on-blur="idCardBlur"></Input>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="出生日期" >
                                <DatePicker type="date" placeholder="请选择出生日期"
                                 v-model="userInfoForm.birthday"

                                ></DatePicker>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="手机" prop="phone">
                                <Input v-model="userInfoForm.phone" placeholder="请输入手机" :disabled="disabled"></Input>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="性别" >
                                <RadioGroup v-model="userInfoForm.sex">
                                    <Radio label='1' >男</Radio>
                                    <Radio label='2'>女</Radio>
                                </RadioGroup>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="咨询日期" prop="consult_time">
                                <DatePicker type="date" placeholder="请选择咨询日期"

                                    v-model="userInfoForm.consult_time"
                                    ></DatePicker>
                            </FormItem>
                        </Col>
                        <Col span="24">
                            <FormItem label="所在区域" >
                                <Select v-model="userInfoForm.province_id"   style="width:15%" placeholder="请选择省" @on-change="changeProvince">
                                    <Option v-for="item in province" :value="item.id" :key="item.id">{{item.name}}</Option>
                                </Select>

                                <Select v-model="userInfoForm.city_id"  style="width:15%" placeholder="请选择市" @on-change="changeCity">
                                    <Option v-for="item in city" :value="item.id" :key="item.id">{{item.name}}</Option>
                                </Select>

                                <Select v-model="userInfoForm.area_id"  style="width:15%" placeholder="请选择区">
                                    <Option v-for="item in area" :value="item.id" :key="item.id">{{item.name}}</Option>
                                </Select>

                                <Input v-model="userInfoForm.address" style="width:50%" placeholder="请输入详细地址"></Input>
                            </FormItem>
                        </Col>
                        <Col span="24">
                            <FormItem label="备注" prop="remark">
                                <Input v-model="userInfoForm.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="200字（含）以内"></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <div class="user_info_wrap">
                        <span class="user_info_title">详细信息</span>
                    </div>
                    <Row>
                        <Col span="8">
                            <FormItem label="民族" >
                                <Input v-model="userInfoForm.nation" placeholder="请输入民族"></Input>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="籍贯" >
                                <Input v-model="userInfoForm.birth_place" placeholder="请输入籍贯"></Input>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="学历" >
                                <Input v-model="userInfoForm.education" placeholder="请输入学历"></Input>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="身高" >
                                <Input v-model="userInfoForm.height" placeholder="请输入身高"></Input>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="体重" >
                                <Input v-model="userInfoForm.weight" placeholder="请输入体重"></Input>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="职业" >
                                <!-- <Input v-model="userInfoForm.job" placeholder="请输入职业"></Input> -->
                                <Select v-model="userInfoForm.job"  placeholder="请选择职业" style="90%">
                                    <Option v-for="item in baseData.industry" :value="item.id" :key="item.id">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>

            <!-- 基本信息 -->
            <div v-if="!showEditUserInfo">
                <div class="user_info_wrap">
                    <span class="user_info_title">基本信息</span>
                    <div>
                        <Button  type="primary" @click="editUserInfo">编辑</Button>
                    </div>
                </div>
                    <Row>
                        <Col span="8">
                            <div class="user_info_text_wrap">
                                <span>姓名：</span>
                                <span>{{userInfoFormBackup.name}}</span>
                            </div>
                        </Col>
                        <Col span="8">
                            <div class="user_info_text_wrap">
                                <span>身份证：</span>
                                <span>{{userInfoFormBackup.id_card}}</span>
                            </div>
                        </Col>
                        <Col span="8">
                            <div class="user_info_text_wrap">
                                <span>出生日期：</span>
                                <span>{{userInfoFormBackup.birthday}}</span>
                            </div>
                        </Col>
                        <Col span="8">
                            <div class="user_info_text_wrap">
                                <span>手机：</span>
                                <span>{{userInfoFormBackup.phone}}</span>
                                <Button
          class="item"
          icon="ios-eye-outline"
          type="text"
          @click="getphone"
          ></Button
        >
                            </div>
                        </Col>
                        <Col span="8">
                            <div class="user_info_text_wrap">
                                <span>性别：</span>
                                <span>{{userInfoFormBackup.sex_text}}</span>
                            </div>
                        </Col>
                        <Col span="8">
                            <div class="user_info_text_wrap">
                                <span>咨询日期：</span>
                                <span>{{userInfoFormBackup.consult_time}}</span>
                            </div>
                        </Col>
                        <Col span="24">
                            <div class="user_info_text_wrap">
                                <span>所在区域：</span>
                                <span>{{userInfoFormBackup.region+userInfoForm.address}}</span>
                            </div>
                        </Col>
                        <Col span="24">
                            <div class="user_info_text_wrap">
                                <span>备注：</span>
                                <span>{{userInfoFormBackup.remark}}</span>
                            </div>
                        </Col>
                    </Row>
                    <div class="user_info_wrap">
                        <span class="user_info_title">详细信息</span>
                    </div>
                    <Row>
                        <Col span="8">
                            <div class="user_info_text_wrap">
                                <span>民族：</span>
                                <span>{{userInfoFormBackup.nation}}</span>
                            </div>
                        </Col>
                        <Col span="8">
                            <div class="user_info_text_wrap">
                                <span>籍贯：</span>
                                <span>{{userInfoFormBackup.birth_place}}</span>
                            </div>
                        </Col>
                        <Col span="8">
                            <div class="user_info_text_wrap">
                                <span>学历：</span>
                                <span>{{userInfoFormBackup.education}}</span>
                            </div>
                        </Col>
                        <Col span="8">
                            <div class="user_info_text_wrap">
                                <span>身高：</span>
                                <span>{{userInfoFormBackup.height!=''?userInfoFormBackup.height+'CM':''}}</span>
                            </div>
                        </Col>
                        <Col span="8">
                            <div class="user_info_text_wrap">
                                <span>体重：</span>
                                <span>{{userInfoFormBackup.weight!=''?userInfoFormBackup.weight+'KG':''}}</span>
                            </div>
                        </Col>
                        <Col span="8">
                            <div class="user_info_text_wrap">
                                <span>职业：</span>
                                <span>{{userInfoFormBackup.job}}</span>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </div>

            <!-- 录入信息表格 -->
            <div class="user_info_wrap">
                <span class="user_info_title">录入信息列表</span>
                <div>
                    <Button  type="primary" @click="addChannel">添加渠道</Button>
                </div>
            </div>
            <Table  stripe border  :columns="tabEntryColumns" :data="tabEntryData"></Table>

            <!-- 门店信息表格 -->
            <div class="user_info_wrap">
                <span class="user_info_title">门店信息列表</span>
                <div>
                    <Button  type="primary" @click="addStores">添加跟进门店</Button>
                </div>
            </div>
            <Table  stripe border  :columns="tabStoresColumns" :data="tabStoresData"></Table>

            <!-- 产妇信息表格 -->
            <div class="user_info_wrap">
                <span class="user_info_title">产妇信息列表</span>
                <div>
                    <Button  v-if="tabMaternalData.length==0" type="primary" @click="addMaternal">添加产妇信息</Button>
                </div>
            </div>
            <Table  stripe border  :columns="tabMaternalColumns" :data="tabMaternalData"></Table>

            <!-- 跟进人表格 -->
            <div class="user_info_wrap">
                <span class="user_info_title">跟进人列表</span>
                <div>
                    <Button  type="primary" @click="addWithPeople">添加跟进人</Button>
                </div>
            </div>
            <Table  stripe border :columns="tabWithPeopleColumns" :data="tabWithPeopleData"></Table>

            <div class="demo-drawer-footer">
                <Button  type="primary" @click="isEditorOk">收起</Button>
            </div>
        </Drawer>

        <!-- 添加|编辑渠道对话框 -->
        <Modal
            v-model="showAddChannel"
            :closable="false"
            :mask-closable="false"
            class-name="vertical-center-modal">
                <p slot="header" class="modal_title">
                    <span>{{isModalTitle==1?'添加渠道':(isModalTitle==2?'编辑渠道':'')}}</span>
                </p>
                <!-- <p v-if="isModalTitle==1" class="modal_text">*增加渠道会让您成为第二录入人，可查看该客户所有回访信息</p> -->
                <Alert v-if="isModalTitle==1" type="error">*增加渠道会让您成为第二录入人，可查看该客户所有回访信息</Alert>
                <Form  ref="addChannelForm" :model="addChannelForm" :rules="addChannelFormRule" :label-width="80" >
                    <FormItem label="渠道" prop="department_id">
                        <Select v-model="addChannelForm.department_id"  @on-change="changeAddChannel" style="width:90%" placeholder="请选择部门">
                            <Option v-for="item in departmentList" :key="item.id" :value="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="" prop="channel_id">
                        <Select v-model="addChannelForm.channel_id"  style="width:90%" filterable placeholder="请选择渠道">
                            <Option v-for="item in channelAddList" :key="item.id" :value="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="渠道说明" >
                        <Input v-model="addChannelForm.channel_explain" style="width:90%" type="textarea" :autosize="{minRows: 2,maxRows: 5}"  :maxlength="100" placeholder="请在100字内描述特有的渠道说明"></Input>
                    </FormItem>
                    <FormItem label="备注" prop="remark">
                        <Input v-model="addChannelForm.remark" style="width:90%"  type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请在200字内描述增加渠道的原因"></Input>
                    </FormItem>
                </Form>

                <div slot="footer">
                    <Button type="primary" size="large"  @click="handleSubmit('addChannelForm')">确定</Button>
                    <Button  size="large"  @click="handleReset('addChannelForm')">取消</Button>
                </div>
        </Modal>
        <!-- 添加|编辑跟进门店对话框 -->
        <Modal
            v-model="showAddStores"
            :closable="false"
            :mask-closable="false"
            class-name="vertical-center-modal">
                <p slot="header"  class="modal_title">
                    <span>{{isModalTitle==3?'添加跟进门店':(isModalTitle==4?'编辑跟进门店':'')}}</span>
                </p>
                <!-- <p v-if="isModalTitle==4" class="modal_text">*距分配时间已超过7天，不能设置为无效</p> -->
                <!-- <Alert v-if="isModalTitle==4" type="error">*距分配时间已超过7天，不能设置为无效</Alert> -->
                <Form  ref="addStoresForm" :model="addStoresForm" :rules="addStoresFormRule" :label-width="80" >
                    <FormItem label="跟进门店" prop="follow_store_id">
                        <Select v-model="addStoresForm.follow_store_id" :disabled="isModalTitle==4?true:false"  style="width:90%" placeholder="请选择门店">
                            <Option v-for="item in storeList" :key="item.id" :value="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="客户分组" prop="follow_group_id">
                        <Select v-model="addStoresForm.follow_group_id"  style="width:90%" placeholder="请选择分组">
                            <Option v-for="item in customerGroudList" :key="item.id" :value="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="跟进结果" prop="come_status">
                        <Select :disabled="comeStatus" v-model="addStoresForm.come_status"  style="width:90%" placeholder="请选择是否已到店">
                            <Option
                    v-for="item in baseData.come_status"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                        </Select>
                    </FormItem>
                    <FormItem label="到店方式" prop="come_id" v-if="addStoresForm.come_status=='2'">
                        <Select v-model="addStoresForm.come_id"  style="width:90%" placeholder="请选择到店方式">
                            <Option v-for="item in returnSettingList" :value="item.id" :key="item.id">{{item.return_info}}</Option>
                        </Select>
                    </FormItem>
                    
                    <FormItem label="到店时间"  style="width:90%" prop="come_date" v-if="addStoresForm.come_status=='2'">
                      <DatePicker 
                        v-model="addStoresForm.come_date"
                         format="yyyy-MM-dd"
                        placeholder="请选择"
                        style="display: block"
                      ></DatePicker>
                    </FormItem>
                     
                     <FormItem label="到店结果" style="width:90%"  prop="arrival_result_id" v-if="addStoresForm.come_status=='2'">
                    <!-- <RadioGroup v-model="addStoresForm.arrival_result_id">
                      <Radio
                        :label="item['id'].toString()"
                        v-for="item in arrival_result"
                        :key="item['id'].toString()"
                        >{{ item["result"] }}</Radio
                      >
                    </RadioGroup> -->

                    <Select placeholder="到店结果"
                     v-if="addStoresForm.come_status == '2'"
                     v-model="addStoresForm.arrival_result_id">
                <Option
                  v-for="item in arrival_result"
                  :value="item['id'].toString()"
                  :key="item['id'].toString()"
                  >{{ item["result"] }}</Option
                >
              </Select>

                  </FormItem>
              
                  <FormItem label="到店结果" prop="arrival_result_id" v-if="addStoresForm.arrival_result_id == '0'" >
                       <Input
                      v-model="addStoresForm.other"
                      :maxlength="20"
                      placeholder="1-12个字符"
                    ></Input>
                  </FormItem>
   </Form>
                <div slot="footer">
                    <Button type="primary" size="large"  @click="handleSubmit('addStoresForm')">确定</Button>
                    <Button  size="large"  @click="handleReset('addStoresForm')">取消</Button>
                </div>
               
        </Modal>

        <!-- 添加|编辑产妇信息对话框 -->
        <Modal
            v-model="showAddMaternal"
            :closable="false"
            :styles="stylesModal"
            :mask-closable="false"
            class-name="vertical-center-modal">
                <p slot="header"  class="modal_title">
                    <span>{{isModalTitle==5?'添加产妇信息':(isModalTitle==6?'编辑产妇信息':'')}}</span>
                </p>
              <!--  v-model="addMaternalForm.child_birth"  -->
                <Form ref="addMaternalForm" :model="addMaternalForm"  :rules="addMaternalFormRule" :label-width="80" style="width:100%;height:340px;overflow: auto">
                    <FormItem label="预产期" prop="child_birth">
                        <DatePicker type="date" placeholder="请选择预产期"
                        :value="addMaternalForm.child_birth"
                        @on-change="changeChild_birth"
                        style="width:100%"></DatePicker>
                    </FormItem>
                    <!-- <FormItem label="分娩医院"  >
                        <Input type="text" v-model="addMaternalForm.hospital"  placeholder="请输入"></Input>
                    </FormItem> -->
                    <FormItem label="分娩医院"  >
                      <Select
                        v-model="addMaternalForm.hospital"
                        filterable
                        remote
                        clearable
                        @on-query-change="remoteMethod"
                        :remote-method="remoteMethod1"
                        :loading="remoteLoading">
                            <Option
                            v-for="(option, index) in hospitalList"
                            :key="index"
                            :value="option.label"
                            :label="option.label">
                                <span>{{option.label}}</span>
                                <span style="float:right;color:#ccc">{{option.value}}</span>
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="家属信息"  >
                        <Button type="primary" long @click="addFamily" icon="md-add" style="width:100px">添加</Button>
                    </FormItem>
                    <!--  :prop="'maternal_family.'+index+'.name'"
                            :rules="{required: true, message: '家属姓名不能为空', trigger: 'blur'}" -->
                    <FormItem
                            v-for="(item, index) in addMaternalForm.maternal_family"
                            :key="index"
                            :label="'家属信息'"
                            :prop="'maternal_family.'+index+'.name'"
                            :rules="{required: true, message: '家属姓名不能为空', trigger: 'blur'}"
                            >
                            <Input type="text" v-model="item.name" placeholder="请输入家属姓名" ></Input>

                            <Select v-model="item.relation"    placeholder="请选择家属关系"  class="mr-t-10">
                                <Option value="夫妻">夫妻</Option>
                                <Option value="男方家属">男方家属</Option>
                                <Option value="女方家属">女方家属</Option>
                                <Option value="其他">其他</Option>
                            </Select>

                            <Input type="text"  :maxlength="11" v-model="item.phone" placeholder="请输入家属联系方式"  class="mr-t-10"></Input>
                            
                            <Input type="text" v-model="item.id_card" placeholder="请输入身份证号" class="mr-t-10"></Input>
                            
                            <Input type="text" v-model="item.address" placeholder="请输入联系地址" class="mr-t-10"></Input>
                            
                            <Button type="error"  @click="removeFamily(index)" class="mr-t-10">删除</Button>
                    </FormItem>
                </Form>

                <div slot="footer">
                    <Button type="primary" size="large"  @click="handleSubmit('addMaternalForm')">确定</Button>
                    <Button  size="large"  @click="handleReset('addMaternalForm')">取消</Button>
                </div>
        </Modal>

        <!-- 添加跟进人对话框 -->
        <Modal
            v-model="showAddWithPeople"
            :closable="false"
            :styles="stylesModal"
            :scrollable="true"
            :mask-closable="false"
            class-name="vertical-center-modal">
                <p slot="header"  class="modal_title">
                    <span>添加跟进人</span>
                </p>
                <Form ref="addWithPeopleForm" :model="addWithPeopleForm" :rules="addWithPeopleFormRule" :label-width="80" style="width:70%">
                    <FormItem label="门店" prop="store_id">
                        <Select v-model="addWithPeopleForm.store_id"  placeholder="请选择门店" @on-change="changeAddDepartment" >
                           <Option v-for="item in tabStoresData" :key="item.id" :value="item.follow_store_id">{{item.follow_store_name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="部门" prop="department_id">
                        <Select v-model="addWithPeopleForm.department_id" placeholder="请选择部门" @on-change="changeAddFollowr">
                            <Option v-for="item in followDepartmentList" :key="item.id" :value="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="跟进人" prop="follow_user">
                        <Select v-model="addWithPeopleForm.follow_user"    placeholder="请选择跟进人">
                            <Option v-for="item in followrAddList" :key="item.id" :value="item.id">{{ item.user_name }}</Option>
                        </Select>
                    </FormItem>
                </Form>

                <div slot="footer">
                    <Button type="primary" size="large"  @click="handleSubmit('addWithPeopleForm')">确定</Button>
                    <Button  size="large"  @click="handleReset('addWithPeopleForm')">取消</Button>
                </div>
        </Modal>
    </div>
</template>
<script>
export default {
  name: "userDetails",
  props: {
    showUserDetails: Boolean,
    userId: String,
    direct: String,
  },
  data() {
    return {
      remoteLoading: false,
      hospitalList: [],
      disabled: false,
      storeList: [],
      customerGroudList: [],
      departmentList: [],
      channelList: [],
      channelAddList: [],
      followrList: [],
      followrAddList: [],
      followrBatchAddList: [],
      followDepartmentList: [],
      returnSettingList: [],
      baseData: baseData,
      arrival_result: [],

      // ************ 回访信息 ************

      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static",
      },
      stylesModal: {
        height: "500px",
      },
      // ************ 客户详情 ************
      isModalTitle: 1,
      // 基本信息
      showEditUserInfo: false,
      userInfoFormBackup: {},
      province: [],
      city: [],
      area: [],
      userInfoForm: {},
      userInfoFormRule: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机", trigger: "blur" }],
        consult_time: [
          {
            required: true,
            type: "date",
            message: "请选择咨询日期",
            trigger: "change",
          },
        ],
        remark: [
          { required: true, message: "请输入", trigger: "blur" },
          {
            type: "string",
            max: 200,
            message: "备注不能大于200字",
            trigger: "blur",
          },
        ],
      },
      // 录入信息
      showAddChannel: false,
      tabEntryColumns: [
        {
          title: "序号",
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "录入方式",
          key: "insert_way_text",
          align: "center",
        },
        {
          title: "渠道所属部门",
          key: "department_name",
          align: "center",
        },
        {
          title: "渠道名称",
          key: "channel_name",
          align: "center",
        },
        {
          title: "渠道说明",
          key: "channel_explain",
          align: "center",
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
        },
        {
          title: "录入时间",
          key: "created_at",
          align: "center",
        },
        {
          title: "录入人",
          key: "agent_name",
          align: "center",
        },
        {
          title: "操作",
          width: 100,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    // marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      if (
                        params.row.channel_tag == 1 &&
                        params.row.is_first_enter == 0
                      ) {
                        this.$Notice.warning({
                          title: "提示",
                          desc: "抱歉，只有第一录入人才能编辑第一渠道！",
                        });
                      } else {
                        this.isModalTitle = 2;
                        this.apiChannelAll(
                          params.row.department_id,
                          2,
                          params.row.channel_id
                        );
                        this.addChannelForm.member_id = this.userInfoForm.id;
                        this.addChannelForm.id = params.row.id;
                        this.addChannelForm.department_id =
                          params.row.department_id;
                        this.addChannelForm.channel_explain =
                          params.row.channel_explain;
                        this.addChannelForm.remark = params.row.remark;
                        this.showAddChannel = true;
                      }
                    },
                  },
                },
                "编辑"
              ),
            ]);
          },
        },
      ],
      tabEntryData: [],
      addChannelForm: {
        member_id: "",
        id: "",
        department_id: "",
        channel_id: "",
        channel_explain: "",
        remark: "",
      },
      addChannelFormRule: {
        department_id: [
          {
            required: true,
            message: "请选择部门",
            trigger: "change",
            type: "number",
          },
        ],
        channel_id: [
          {
            required: true,
            message: "请选择渠道",
            trigger: "change",
            type: "number",
          },
        ],

        remark: [
          { required: true, message: "请输入", trigger: "blur" },
          {
            type: "string",
            max: 200,
            message: "备注不能大于200字",
            trigger: "blur",
          },
        ],
      },
      // 门店信息
      showAddStores: false,
      tabStoresColumns: [
        {
          title: "序号",
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "跟进门店",
          key: "follow_store_name",
          align: "center",
        },
        {
          title: "客户分组",
          key: "member_group_name",
          align: "center",
        },
        {
          title: "到店状态",
          key: "come_status",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.come_status == 1
                  ? "未到店"
                  : params.row.come_status == 2
                  ? "已到店"
                  : ""
              ),
            ]);
          },
        },
        {
          title: "到店方式",
          key: "come_name",
          align: "center",
        },
        {
          title: "分配至门店时间",
          key: "created_at",
          align: "center",
        },
        {
          title: "分配人",
          key: "allot_name",
          align: "center",
        },
        {
          title: "操作",
          width: 100,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    // marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.isModalTitle = 4;

                      this.addStoresForm.member_id = this.userInfoForm.id;
                      this.addStoresForm.id = params.row.id;
                      this.addStoresForm.follow_store_id =
                        params.row.follow_store_id;
                      this.addStoresForm.follow_group_id =
                        params.row.member_group_id;
                      this.addStoresForm.come_status =
                        params.row.come_status.toString();

                      if (this.addStoresForm.come_status == "2") {
                        this.comeStatus = true;
                        this.addStoresForm.come_date = params.row.come_date;
                      }

                      this.addStoresForm.come_id = params.row.come_id;

                      this.showAddStores = true;
                    },
                  },
                },
                "编辑"
              ),
            ]);
          },
        },
      ],
      tabStoresData: [],
      comeStatus: false, //是否禁止到店方式
      addStoresForm: {
        id: "",
        member_id: "",
        follow_store_id: "",
        follow_group_id: "",
        come_status: "",
        come_id: "",
        come_date: "",
        arrival_result_id:'',
        other:''
      },
      addStoresFormRule: {
        // come_date: [
        //   { required: true, message: "请输入到店时间", trigger: "change" },
        // ],
        follow_store_id: [
          {
            required: true,
            message: "请选择门店",
            trigger: "change",
            type: "number",
          },
        ],
        follow_group_id: [
          {
            required: true,
            message: "请选择客户分组",
            trigger: "change",
            type: "number",
          },
        ],
        come_status: [
          { required: true, message: "请选择是否已到店", trigger: "change" },
        ],
        come_id: [
          {
            required: true,
            message: "请选择到店方式",
            trigger: "change",
            type: "number",
          },
        ],
      },
      // 产妇信息
      showAddMaternal: false,
      tabMaternalColumns: [
        {
          title: "序号",
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "预产期",
          key: "child_birth",
          align: "center",
        },
        {
          title: "分娩医院",
          key: "hospital",
          align: "center",
        },
        {
          title: "家属信息",
          key: "maternal_family_text",
          align: "center",
        },
        {
          title: "创建时间",
          key: "created_at",
          align: "center",
        },
        {
          title: "状态",
          width: 100,
          key: "use_state_text",
          align: "center",
        },
        {
          title: "操作",
          width: 100,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    display: params.row.use_state == 1 ? "block" : "none",
                  },
                  on: {
                    click: () => {
                      this.isModalTitle = 6;

                      this.addMaternalForm.member_id = this.userInfoForm.id;
                      // 处理家属信息，确保每个家属都有id_card和address字段
                      this.addMaternalForm.maternal_family = params.row.maternal_family_list.map(item => ({
                        ...item,
                        id_card: item.id_card != null ? item.id_card : '',
                        address: item.address != null ? item.address : ''
                      }));
                      this.addMaternalForm.maternal_info_id =
                        params.row.maternal_info_id;
                      this.addMaternalForm.child_birth = params.row.child_birth;
                      this.addMaternalForm.hospital = params.row.hospital;

                      this.showAddMaternal = true;
                    },
                  },
                },
                "编辑"
              ),
            ]);
          },
        },
      ],
      tabMaternalData: [],
      familyIndex: 1,
      addMaternalForm: {
        member_id: "",
        maternal_info_id: "",
        child_birth: "",
        hospital: "",
        maternal_family: [
          // {
          //     name: '',
          //     relation:'',
          //     phone:''
          // }
        ],
      },
      addMaternalFormRule: {
        child_birth: [
          {
            required: true,
            type: "string",
            message: "请选择预产期",
            trigger: "change",
          },
        ],
      },
      // 跟进人表格
      showAddWithPeople: false,
      tabWithPeopleColumns: [
        {
          title: "序号",
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "姓名",
          key: "follow_user_name",
          align: "center",
        },
        {
          title: "跟进状态",
          key: "follow_status_text",
          align: "center",
        },
        {
          title: "分配时间",
          key: "allot_time",
          align: "center",
        },
        {
          title: "所属门店",
          key: "follow_store_name",
          align: "center",
        },
        {
          title: "部门",
          key: "follow_department_name",
          align: "center",
        },
        {
          title: "职位",
          key: "follow_position_name",
          align: "center",
        },
        {
          title: "分配人",
          key: "follow_agent_name",
          align: "center",
        },
        {
          title: "操作",
          width: 160,
          align: "center",
          render: (h, params) => {
            if (params.row.follow_agent_status == 6) {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "提示",
                          width: 600,
                          content:
                            "<p>该跟进人于" +
                            params.row.abandon_time +
                            "放弃跟进，是否确认让其重新跟进？</p>",
                          onOk: () => {
                            this.apiAgainFollow(params.row.id);
                          },
                          onCancel: () => {},
                        });
                      },
                    },
                  },
                  "重新跟进"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small",
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "删除跟进人",
                          width: 600,
                          content:
                            "<p>删除该跟进人后，跟进人无法继续回访和查看该客户，是否确认删除？</p>",
                          onOk: () => {
                            this.apiDeleteFollow(params.row.id);
                          },
                          onCancel: () => {},
                        });
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            } else {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small",
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "删除跟进人",
                          width: 600,
                          content:
                            "<p>删除该跟进人后，跟进人无法继续回访和查看该客户，是否确认删除？</p>",
                          onOk: () => {
                            this.apiDeleteFollow(params.row.id);
                          },
                          onCancel: () => {},
                        });
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            }
          },
        },
      ],
      tabWithPeopleData: [],
      addWithPeopleForm: {
        member_id: "",
        store_id: "",
        department_id: "",
        follow_user: "",
      },
      addWithPeopleFormRule: {
        store_id: [
          {
            required: true,
            message: "请选择门店",
            trigger: "change",
            type: "number",
          },
        ],
        department_id: [
          {
            required: true,
            message: "请选择部门",
            trigger: "change",
            type: "number",
          },
        ],
        follow_user: [
          {
            required: true,
            message: "请选择跟进人",
            trigger: "change",
            type: "number",
          },
        ],
      },
    };
  },
  mounted() {
    this.apiStoreAll();
    this.apiGetMemberGroupList();
    this.getReturnSettingList();
    this.apiDepartmentAll();
    this.apiArrivalResultList();
  },
  methods: {
    //获取医院
    apiGetHospital(address) {
      serve
        .fetchGet(api.crmChildbirthHospital, { address: address })
        .then((data) => {
          console.log(data);
          let arr = [{ value: address, label: address }];
          data.result.map((item) => {
            arr.push({
              value: item.address_region,
              label: item.address_name,
            });
          });
          this.hospitalList = arr;
          // console.log('this.hospitalList',this.hospitalList)
          // console.log(' this.remoteLoading', this.remoteLoading)
          setTimeout(() => {
            this.remoteLoading = false;
          }, 200);
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    remoteMethod1(query) {},
    //医院检索
    remoteMethod(query) {
      // console.log('query remoteMethod',query)
      // console.log('hospitalList',this.hospitalList)
      this.remoteLoading = true;
      if (query !== "") {
        this.apiGetHospital(query);
      } else {
        this.hospitalList = [];
        this.remoteLoading = false;
      }
    },
    // 门店
    apiStoreAll() {
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberStoreAll;
          break;
        case "curtomerManagement":
          apiUrl = api.storeMemberStoreAll;
          break;
      }
      serve
        .fetchGet(apiUrl, {})
        .then((data) => {
          this.storeList = data.data;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    // 客户分组
    apiGetMemberGroupList() {
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberGroupAll;
          break;
        case "curtomerManagement":
          apiUrl = api.storeMemberGroupAll;
          break;
      }
      serve
        .fetchGet(apiUrl, {})
        .then((data) => {
          this.customerGroudList = data.member_groups;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //部门
    apiDepartmentAll(store_id) {
      let params = {};
      if (store_id) {
        params.store_id = store_id;
      }
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberDepartmentAll;
          break;
        case "curtomerManagement":
          apiUrl = api.memberDepartmentAll;
          break;
      }
      serve
        .fetchGet(apiUrl, params)
        .then((data) => {
          console.log(data);
          if (store_id) {
            this.followDepartmentList = data.data;
          } else {
            this.departmentList = data.data;
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //渠道
    apiChannelAll(id, type = 1, channel_id = null) {
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberChannelAll;
          break;
        case "curtomerManagement":
          apiUrl = api.memberStoreMemberAll;
          break;
      }
      serve
        .fetchGet(apiUrl, { department_id: id })
        .then((data) => {
          if (type == 1) {
            this.channelList = data.data;
          } else {
            this.channelAddList = data.data;
            this.addChannelForm.channel_id = channel_id;
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    getphone() {
      var params = {
        id: this.userInfoFormBackup.id,
      };
      serve.fetchGet(api.getMemberPhone, params).then((res) => {
        this.userInfoFormBackup.phone = res.member.phone;
      });
    },
    //获取跟进人
    apiFollowr(id, store_id, type = 1) {
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberAgentAll;
          break;
        case "curtomerManagement":
          apiUrl = api.memberStoreMemberAgentAll;
          break;
      }
      serve
        .fetchGet(apiUrl, { department_id: id, store_id: store_id })
        .then((data) => {
          switch (type) {
            case 1:
              this.followrList = data.data;
              break;
            case 2:
              this.followrAddList = data.data;
              break;
            case 3:
              this.followrBatchAddList = data.data;
              break;
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //省
    apiProvince() {
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberGetProvinceList;
          break;
        case "curtomerManagement":
          apiUrl = api.memberGetProvinceList;
          break;
      }
      serve
        .fetchGet(apiUrl, {})
        .then((data) => {
          this.province = data.districts;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //市
    apiCity(id) {
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberGetCityList;
          break;
        case "curtomerManagement":
          apiUrl = api.memberGetCityList;
          break;
      }
      serve
        .fetchGet(apiUrl, { upid: id })
        .then((data) => {
          this.city = data.districts;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //区
    apiArea(id) {
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberGetCityList;
          break;
        case "curtomerManagement":
          apiUrl = api.memberGetCityList;
          break;
      }
      serve
        .fetchGet(apiUrl, { upid: id })
        .then((data) => {
          this.area = data.districts;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //到店方式
    getReturnSettingList() {
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberShopWay;
          break;
        case "curtomerManagement":
          apiUrl = api.memberShopWay;
          break;
      }
      serve
        .fetchGet(apiUrl, {})
        .then((data) => {
          console.log("到店方式", data);
          this.returnSettingList = data.return_settings;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },

    // 添加|修改渠道
    apiAddChannel() {
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberSaveChannelInfo;
          break;
        case "curtomerManagement":
          apiUrl = api.memberSaveChannelInfo;
          break;
      }
      serve
        .fetchPost(apiUrl, this.addChannelForm)
        .then((res) => {
          console.log("添加渠道", res);
          this.$Message.success("设置成功");
          this.apiUserDetailsInfo(this.userId);
          this.showAddChannel = false;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    // 添加|修改跟进门店
    apiAddStores() {
      console.log('apiAddStores')
      let parmas = {
        id: this.addStoresForm.id,
        member_id: this.addStoresForm.member_id,
        follow_store_id: this.addStoresForm.follow_store_id,
        follow_group_id: this.addStoresForm.follow_group_id,
        come_status: this.addStoresForm.come_status,
        come_id: this.addStoresForm.come_id,
        arrival_result_id: this.addStoresForm.arrival_result_id,
        come_date: util.dateFormat(this.addStoresForm.come_date),
        other:
          this.addStoresForm.arrival_result_id == "0"
            ? this.addStoresForm.other
            : "",
      };
      console.log("params", parmas);
      if (this.addStoresForm.come_status == "1") delete parmas.come_id;
      if (this.isModalTitle == 3) delete parmas.id;
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberSaveFollowStore;
          break;
        case "curtomerManagement":
          apiUrl = api.memberSaveFollowStore;
          break;
      }
      serve
        .fetchPost(apiUrl, parmas)
        .then((res) => {
          console.log("添加门店", res);
          this.$Message.success("设置成功");
          this.apiUserDetailsInfo(this.userId);
          this.showAddStores = false;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    apiArrivalResultList() {
      serve.fetchGet(api.arrivalResultList).then((data) => {
        this.arrival_result = data["list"];
        this.arrival_result.push({
          id: "0",
          result: "其它结果",
        });
        console.log("this.arrival_result ", this.arrival_result);
      });
    },
    // 添加|修改产妇信息
    apiAddMaternal() {
      // 验证家属信息
      for (let i = 0; i < this.addMaternalForm.maternal_family.length; i++) {
        let item = this.addMaternalForm.maternal_family[i];
        if (!item.name) {
          this.$Message.error('家属姓名不能为空');
          return;
        }
        if (!item.relation) {
          this.$Message.error('家属关系不能为空');
          return;
        }
        if (!item.phone) {
          this.$Message.error('家属电话不能为空');
          return;
        }
        if (!item.id_card) {
          this.$Message.error('家属身份证号不能为空');
          return;
        }
        if (!item.address) {
          this.$Message.error('家属联系地址不能为空');
          return;
        }
      }
      let params = {
        maternal_family: this.addMaternalForm.maternal_family,
        member_id: this.addMaternalForm.member_id,
        maternal_info_id: this.addMaternalForm.maternal_info_id,
        child_birth: this.dateFormat(this.addMaternalForm.child_birth),
        hospital: this.addMaternalForm.hospital,
      };
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberSaveMaternalOrFamily;
          break;
        case "curtomerManagement":
          apiUrl = api.memberSaveMaternalOrFamily;
          break;
      }
      serve
        .fetchPut(apiUrl, params)
        .then((res) => {
          this.$Message.success("设置成功");
          this.apiUserDetailsInfo(this.userId);
          this.showAddMaternal = false;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    // 删除跟进人
    apiDeleteFollow(id) {
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberDelFollowUser;
          break;
        case "curtomerManagement":
          apiUrl = api.memberDelFollowUser;
          break;
      }
      serve
        .fetchPut(apiUrl + "/" + id, {})
        .then((res) => {
          this.$Message.success("删除成功");
          this.apiUserDetailsInfo(this.userId);
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    // 重新跟进跟进人
    apiAgainFollow(id) {
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberSaveAgainFollowStatus;
          break;
        case "curtomerManagement":
          apiUrl = api.memberSaveAgainFollowStatus;
          break;
      }
      serve
        .fetchPut(apiUrl + "/" + id, {})
        .then((res) => {
          this.$Message.success("设置成功");
          this.apiUserDetailsInfo(this.userId);
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //添加跟进人
    apiAddFollow() {
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberSaveFollowAgent;
          break;
        case "curtomerManagement":
          apiUrl = api.memberSaveFollowAgent;
          break;
      }
      serve
        .fetchPost(apiUrl, this.addWithPeopleForm)
        .then((res) => {
          this.$Message.success("添加成功");
          this.apiUserDetailsInfo(this.userId);
          this.showAddWithPeople = false;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    // 编辑用户信息
    apiEditUserInfo() {
      if (this.userInfoForm.id_card) {
        let result = util.regIdCard(this.userInfoForm.id_card);
        console.log(result);
        if (!result.check) {
          this.$Message.error(result.error);
          return;
        }
      }
      let member = {
        id: this.userInfoForm.id,
        name: this.userInfoForm.name,
        id_card: this.userInfoForm.id_card,
        birthday:
          this.userInfoForm.birthday != ""
            ? this.dateFormat(this.userInfoForm.birthday)
            : "",
        sex: this.userInfoForm.sex,
        consult_time: this.dateFormat(this.userInfoForm.consult_time),
        province_id: this.userInfoForm.province_id,
        city_id: this.userInfoForm.city_id,
        area_id: this.userInfoForm.area_id,
        address: this.userInfoForm.address,
        remark: this.userInfoForm.remark,
        nation: this.userInfoForm.nation,
        birth_place: this.userInfoForm.birth_place,
        education: this.userInfoForm.education,
        height: this.userInfoForm.height,
        weight: this.userInfoForm.weight,
        job: this.userInfoForm.job,
        phone: this.userInfoForm.phone,
      };
      let params = { member };
      let apiUrl = null;
      let url = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberEditMember;
          url = api.allMemberExternalPhoneExist;
          break;
        case "curtomerManagement":
          apiUrl = api.memberEditMember;
          url = api.allMemberExternalPhoneExist;
          break;
      }
      let str = {
        phone: this.userInfoForm.phone,
        edit: 1,
        member_id: this.userInfoForm.id,
      };
      serve
        .fetchGet(url, str)
        .then((res) => {
          console.log(res);
          if (res[0].state) {
            this.$Modal.confirm({
              title: "互换手机号",
              content:
                '<p>手机号 <span style="color:red">' +
                res[0].msg.exist_phone +
                " （" +
                res[0].msg.exist_name +
                '）</span>已存在系统，是否将本客户的手机号<span style="color:red">' +
                res[0].msg.new_phone +
                '</span>与<span style="color:red">' +
                res[0].msg.exist_phone +
                "</span>进行互换</p>",
              onOk: () => {
                this.apiEditMemberInfo(apiUrl, params);
              },
            });
          } else {
            this.apiEditMemberInfo(apiUrl, params);
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    apiEditMemberInfo(apiUrl, params) {
      serve
        .fetchPut(apiUrl, params)
        .then((res) => {
          console.log("编辑用户基本信息", res);
          this.$Message.destroy();
          this.$Message.success("修改成功");
          this.apiUserDetailsInfo(this.userId);
          this.showEditUserInfo = false;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    // 客户详情
    apiUserDetailsInfo(id) {
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberGetMemberDetail;
          break;
        case "curtomerManagement":
          apiUrl = api.memberGetMemberDetail;
          break;
      }
      serve
        .fetchGet(apiUrl + "/" + id, {})
        .then((res) => {
          console.log("客户详情组件", res);
          var dataBackup = JSON.parse(JSON.stringify(res.data));
          dataBackup.sex = dataBackup.sex.toString();
          this.userInfoFormBackup = dataBackup;
          if (
            this.userInfoFormBackup.birthday != null &&
            this.userInfoFormBackup.birthday != "0"
          ) {
            this.userInfoFormBackup.birthday = dataBackup.birthday;
          } else {
            this.userInfoFormBackup.birthday = "";
          }

          var data = JSON.parse(JSON.stringify(res.data));
          data.sex = data.sex.toString();
          this.userInfoForm = data;

          //录入信息表格
          this.tabEntryData = data.channel_info_list;

          //门店信息表格
          this.tabStoresData = data.follow_store_list;

          //产妇信息表格
          if (data.maternal_info_list.length) {
            for (var i = 0; i < data.maternal_info_list.length; i++) {
              var maternal_family_text = [];
              for (
                var j = 0;
                j < data.maternal_info_list[i].maternal_family_list.length;
                j++
              ) {
                maternal_family_text.push(
                  data.maternal_info_list[i].maternal_family_list[j].name +
                    " " +
                    data.maternal_info_list[i].maternal_family_list[j]
                      .relation +
                    " " +
                    data.maternal_info_list[i].maternal_family_list[j].phone
                );
              }
              data.maternal_info_list[i].maternal_family_text =
                maternal_family_text.join("\n");
            }
          }
          this.tabMaternalData = data.maternal_info_list;
          console.log("this.tabMaternalData", this.tabMaternalData);

          //跟进人信息表格
          this.tabWithPeopleData = data.follow_list;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //省
    changeProvince(id) {
      this.userInfoForm.city_id = "";
      this.userInfoForm.area_id = "";
      this.apiCity(id);
    },
    // 市
    changeCity(id) {
      this.userInfoForm.area_id = "";
      this.apiArea(id);
    },
    // 编辑初始化
    editUserInfo() {
      this.apiProvince();
      if (this.userInfoForm.province_id) {
        this.apiCity(this.userInfoForm.province_id);
      }
      if (this.userInfoForm.city_id) {
        this.apiArea(this.userInfoForm.city_id);
      }
      this.showEditUserInfo = true;
    },
    // 改变渠道
    changeAddChannel(id) {
      this.addChannelForm.channel_id = "";
      this.apiChannelAll(id, 2);
    },
    // 改变部门
    changeAddDepartment(id) {
      this.addWithPeopleForm.department_id = "";
      this.addWithPeopleForm.follow_user = "";
      this.apiDepartmentAll(id);
    },
    //改变跟进人
    changeAddFollowr(id) {
      this.addWithPeopleForm.follow_user = "";
      this.apiFollowr(id, this.addWithPeopleForm.store_id, 2);
    },
    //收起
    isEditorOk() {
      this.showEditUserInfo = false;
      this.$emit("Close", false);
      // this.showUserDetails = false
    },
    //校验身份证
    idCardBlur() {
      let result = util.regIdCard(this.userInfoForm.id_card);
      if (!result.check && this.userInfoForm.id_card !== "") {
        this.$Message.error(result.error);
        return;
      }
    },
    // 添加，编辑渠道
    addChannel() {
      this.isModalTitle = 1;
      this.addChannelForm.member_id = this.userInfoForm.id;
      this.channelAddList = [];
      this.addChannelForm.department_id = "";
      this.addChannelForm.channel_id = "";
      this.addChannelForm.channel_explain = "";
      this.addChannelForm.remark = "";
      this.showAddChannel = true;
    },
    // 添加，编辑跟进门店
    addStores() {
      this.isModalTitle = 3;
      this.addStoresForm.member_id = this.userInfoForm.id;
      this.addStoresForm.follow_store_id = "";
      this.addStoresForm.follow_group_id = "";
      this.addStoresForm.come_status = "";
      this.addStoresForm.come_id = "";
      this.addStoresForm.come_date = "";
      this.addStoresForm.arrival_result_id = "";
      this.showAddStores = true;
    },
    // 孕妇信息
    addMaternal() {
      this.addMaternalForm.member_id = this.userInfoForm.id;
      this.isModalTitle = 5;
      this.showAddMaternal = true;
    },
    // 添加家属
    addFamily() {
      this.familyIndex++;
      this.addMaternalForm.maternal_family.push({
        name: "",
        relation: "",
        phone: "",
        id_card: "",
        address: "",
      });
    },
    // 删除家属信息
    removeFamily(index) {
      this.addMaternalForm.maternal_family.splice(index, 1);
    },
    // 添加跟进人
    addWithPeople() {
      this.addWithPeopleForm.store_id = "";
      this.addWithPeopleForm.department_id = "";
      this.addWithPeopleForm.follow_user = "";
      this.showAddWithPeople = true;
    },
    // 确认
    handleSubmit(name) {
      console.log('handleSubmit',name);
      this.$refs[name].validate((valid) => {
        if (valid) {
          switch (name) {
            // 修改用户信息
            case "userInfoForm":
              this.apiEditUserInfo();
              break;
            // 添加 | 修改 渠道
            case "addChannelForm":
              switch (this.isModalTitle) {
                case 1:
                  delete this.addChannelForm.id;
                  this.apiAddChannel();
                  break;
                case 2:
                  this.apiAddChannel();
                  break;
              }
              break;
            case "addStoresForm":
              switch (this.isModalTitle) {
                case 3:
                  this.apiAddStores();
                  break;
                case 4:
                  this.apiAddStores();
                  break;
              }
              break;
            case "addMaternalForm":
              switch (this.isModalTitle) {
                case 5:
                  this.apiAddMaternal();
                  break;
                case 6:
                  this.apiAddMaternal();
                  break;
              }

              break;
            case "addWithPeopleForm":
              this.addWithPeopleForm.member_id = this.userInfoForm.id;
              this.apiAddFollow();
              break;
          }
        } else {
          this.$Message.error("请完善表单");
        }
      });
    },
    // 取消
    handleReset(name) {
      this.$refs[name].resetFields();
      switch (name) {
        case "userInfoForm":
          this.userInfoForm = JSON.parse(
            JSON.stringify(this.userInfoFormBackup)
          );
          this.showEditUserInfo = false;
          break;
        case "addChannelForm":
          this.showAddChannel = false;
          break;
        case "addStoresForm":
          this.comeStatus = false;
          this.showAddStores = false;
          break;
        case "addMaternalForm":
          this.familyIndex = 1;
          this.addMaternalForm.member_id = "";
          this.addMaternalForm.maternal_info_id = "";
          this.addMaternalForm.child_birth = "";
          this.addMaternalForm.hospital = "";
          this.addMaternalForm.maternal_family = [];
          // {name: '',relation:'',phone:''}
          this.showAddMaternal = false;
          break;
        case "addWithPeopleForm":
          this.showAddWithPeople = false;
          break;
      }
    },
    changeChild_birth(val) {
      this.addMaternalForm.child_birth = val;
    },
    //时间格式化
    dateFormat(time) {
      var date = new Date(time);
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + "-" + month + "-" + day;
    },
    //是否可以编辑手机号的权限
    apiEditMemberPhone() {
      let apiUrl = null;
      switch (this.direct) {
        case "chainCustomer":
          apiUrl = api.allMemberEditMemberPhone;
          break;
        case "curtomerManagement":
          apiUrl = api.memberEditMemberPhone;
          break;
      }
      serve
        .fetchGet(apiUrl, {})
        .then((data) => {
          console.log("是否可以编辑手机号的权限", data);
          this.disabled = !data[0];
        })
        .catch((error) => {
          this.disabled = true;
          this.$Message.error(error.response.data.message);
        });
    },
  },
  watch: {
    showUserDetails: function (status) {
      if (status) {
        this.apiUserDetailsInfo(this.userId);
        this.apiEditMemberPhone();
      } else {
        this.userInfoFormBackup = {};
        this.userInfoForm = {};
        this.tabEntryData = [];
        this.tabStoresData = [];
        this.tabMaternalData = [];
        this.tabWithPeopleData = [];
      }
    },
  },
};
</script>
<style scope>
.mr-t-10 {
  margin-top: 10px;
}
.content {
}
.search_bar {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}
.search_bar_item {
  /* text-align: center; */
  margin: 4px;
}
.other_search_bar {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}

.table_wrap {
  margin: 12px 12px 12px 0px;
}
.ivu-btn-icon-only {
  margin-left: 4px;
  padding: 0px !important;
  font-size: 18px !important;
}
.ivu-table-cell {
  white-space: pre-line !important;
}
.ivu-drawer-header-inner {
  font-size: 20px !important;
}
.table_tip {
  height: 24px;
  margin: 0 0 10px 0px;
}
.demo-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  z-index: 10;
}
.user_info_wrap {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  height: 40px;
  color: #464c5b;
  font-weight: 600;
  font-size: 14px;
  line-height: 40px;
  background: #f8f8f9;
  margin: 10px 0;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.vertical-center-modal .ivu-modal {
  top: 0;
}
.modal_title {
  text-align: center;
}
.modal_text {
  color: red;
  text-align: center;
  margin-bottom: 16px;
}
.user_info_text_wrap {
  height: 46px;
  padding-top: 10px;
  padding-left: 32px;
  /* line-height: 56px; */

  /* padding: 10px; */
}
.TimelineItemTime {
  font-size: 14px;
  font-weight: bold;
}
.TimelineItemContent {
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/commonTmp/CRM/CustomerManagementTmp/userDetails.vue